// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // url: "https://face.identy.io",
  "face_url": "https://face-sdk-dev-v2.verxid.site",
  background_service_url: "https://background-removal.verxid.site",
  // finger_url: "https://finger-sdk.verxid.site",
  ocrLicense:
    "QUVTAgAAALdsahsTEIUZsIU3O+/5p3UbXS2Crah/AZKNpSEvWXkM3lVjE161KJpCHQcGCmCwCTKOPxrjk6ajO52qZXuXoY6Wc7Ktou4KjtxDXER8ZWPAxzNKdXaJEMtsxPzRTAdZyIfJDZRDe5INVIZZ3izS58kEnvgBnN1iwcOzHsYxv7oNzI679K4uJQb1cxvR5mSnfkc=",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
